// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import CheckboxList from '../../../shared/components/checkbox-list-with-label/checkbox-list';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {translate} from '../../../shared/services/translation-service';

function handleRequestTypeChange(requestType, isSelected) {

    const sanitizedRequestType = new KeyValuePair({
        key: requestType.key,
        value: requestType.value
    });

    this.actions.updateSelectedPartRequestType(sanitizedRequestType, isSelected);

}

const RequestTypeFacet = props => {

    const initialState = createHashMap(props.facets.requestTypes.selectedTypes, 'key');

    const body = (
        <CheckboxList
            initialState={initialState}
            isLabelTranslated={false}
            list={addCollectionLabels(props.facets.requestTypes.allowedTypes, 'value')}
            onChange={props::handleRequestTypeChange}
            uid='key'
        />
    );

    return (
        <Accordion
            accordionId='checkbox-filter-accordion'
            body={body}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            title={translate(props.title)}
        />
    );

};

RequestTypeFacet.displayName = 'RequestTypeFacet';
RequestTypeFacet.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.object.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
};

export default RequestTypeFacet;



// WEBPACK FOOTER //
// ./src/part-requests/shared/components/request-type-facet.js